<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">{{ feeSchedule.Name }}</h4>
</div>
<div class="modal-body">
  <tabset #tabs>
    <tab heading="Procedure Codes">
      <app-grid-wrapper #feeScheduleProcCodesGrid></app-grid-wrapper>
    </tab>
    <tab heading="Revenue Codes" (selectTab)="revCodesSelect()">
      <app-grid-wrapper #feeScheduleRevCodesGrid></app-grid-wrapper>
    </tab>
  </tabset>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">Ok</button>
</div>
